import React from 'react';
import './OfficeInfo.css';
import 'react-icons/ti';

const Accordion = ({ items = [] }) => {
  const [activeIndex, setActiveIndex] = React.useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-list">
      {items.map((item, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? 'open' : ''}`}
        >
          <div className="faq-question" onClick={() => toggleAccordion(index)}>
            <h4>{item.question}</h4>
            <span className="faq-icon" style={{ fontSize: '1.5rem', color: '#0ba360' }}>{activeIndex === index ? '-' : '+'}</span>
          </div>
          <div
            className="faq-answer"
            style={{
              maxHeight: activeIndex === index ? '500px' : '0',
              opacity: activeIndex === index ? '1' : '0',
              paddingTop: '1rem'
            }}
          >
            <p>{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export const OfficePolicy = () => {
    const policyFaqs = [
        {
            question: "What is your appointment cancellation policy?",
            answer: "We require 24 hours notice for appointment cancellations. Late cancellations or no-shows will result in a fee. Please call our office as soon as possible if you need to reschedule."
        },
        {
            question: "How do I request prescription refills?",
            answer: "Please contact your pharmacy directly for refill requests. They will send us an electronic request. Allow 48-72 hours for processing. For controlled substances, you must schedule an appointment."
        },
        {
            question: "What should I bring to my first appointment?",
            answer: "Please bring your photo ID, insurance card, a list of current medications, medical records from previous providers, and any relevant imaging or lab results. Arrive 15 minutes early to complete necessary paperwork."
        },
        {
            question: "How do I access my medical records?",
            answer: "You can access your records through our patient portal. For complete medical records, submit a written request to our office. Processing may take 7-10 business days."
        },
        {
            question: "What are your payment policies?",
            answer: "We accept most major insurance plans. Co-payments are due at the time of service. For self-pay patients, payment is required at the time of visit. We accept credit cards, debit cards, and cash."
        }
        
    ];

    return (
        <div className="office-policy-section">
            <div className="section-header">
                <span>Patient Guidelines</span>
                <h2>Office Policies</h2>
            </div>

            <div className="office-policy-container">
                <div className="policy-details">
                    {/*<h3>General Office Policies</h3>*/}
                    <div className="policy-section">
                        <h4>Appointments</h4>
                        <p>Please arrive 15 minutes before your scheduled appointment time. This allows time for parking and completing any necessary paperwork.</p>
                    </div>
                    
                    <div className="policy-section">
                        <h4>Insurance and Payments</h4>
                        <p>We accept most major insurance plans. Please bring your current insurance card to every visit. Co-payments and deductibles are due at the time of service. For self-pay patients, payment is expected at the time of visit.</p>
                    </div>
                    
                    <div className="policy-section">
                        <h4>Medical Records</h4>
                        <p>For complete medical records requests, please submit a written request to our office. Processing time is typically 10 business days.</p>
                    </div>
                    
                    <div className="policy-section">
                        <h4>Prescription Refills</h4>
                        <p>For prescription refills, please contact your pharmacy directly. They will send us an electronic request. Please allow 48-72 hours for processing. For controlled substances, an appointment is required.</p>
                    </div>
                    <div className="policy-section">
                        <h4>No-Show</h4>
                        <p>We value your time and appreciate your business. Please note that if you cancel your appointment within 24 hours of the scheduled time, a $50 fee will apply. This same fee will also be charged in the event of a no-show. Thank you for your understanding and cooperation.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfficePolicy;
